function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import Tippy from '@tippy.js/react';
import styled from 'styled-components';
import cn from 'classnames';
import 'tippy.js/dist/tippy.css';
export var Popover = function Popover(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'mouseenter' : _ref$trigger,
      _ref$hoverDelay = _ref.hoverDelay,
      hoverDelay = _ref$hoverDelay === void 0 ? 0 : _ref$hoverDelay,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? null : _ref$content,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? undefined : _ref$visible,
      _ref$targetProps = _ref.targetProps,
      targetProps = _ref$targetProps === void 0 ? {} : _ref$targetProps,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "placement", "trigger", "hoverDelay", "disabled", "content", "visible", "targetProps", "children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focusIsVisible = _useState2[0],
      setFocusIsVisible = _useState2[1]; // Don't render empty or disabled popover


  if (!content || disabled) return React.createElement("span", targetProps, children); // TODO: Do not wrap children with span. Let the consumers figure that out themselves.

  var triggerOnFocus = trigger.includes('focus');
  var hoverWithFocus = triggerOnFocus && trigger.includes('mouseenter');
  var controlled = typeof visible === 'boolean';
  return React.createElement(Tippy, _extends({
    content: content,
    animation: "fade",
    hideOnClick: !(controlled || triggerOnFocus),
    placement: placement,
    delay: hoverDelay,
    trigger: trigger,
    enabled: !disabled,
    className: cn('bbui-popover', className),
    visible: triggerOnFocus ? focusIsVisible : visible
  }, rest), React.createElement("span", _extends({
    onFocus: function onFocus() {
      return setFocusIsVisible(true);
    },
    onBlur: function onBlur() {
      return setFocusIsVisible(false);
    },
    onMouseEnter: function onMouseEnter() {
      return hoverWithFocus && setFocusIsVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return hoverWithFocus && setFocusIsVisible(false);
    }
  }, targetProps), children));
};
var PopoverDefaultStyle = styled(Popover).withConfig({
  displayName: "Popover__PopoverDefaultStyle",
  componentId: "n8elvk-0"
})(["&&{z-index:", ";border-radius:0;color:", ";background-color:", ";box-shadow:0 2px 6px 0 rgba(0,0,0,0.5);.tippy-content{padding:0;}.tippy-arrow::before{content:'';position:absolute;width:10px;height:10px;z-index:-1;left:50%;box-sizing:border-box;transform-origin:0 0;box-shadow:-2px 2px 2px 0px rgba(0,0,0,0.15);}&[data-placement^='top'] .tippy-arrow{border-top-color:", ";&:before{transform:rotate(-45deg);bottom:-3px;margin-left:-7px;box-shadow:-2px 2px 2px 0px rgba(0,0,0,0.2);}}&[data-placement^='bottom'] .tippy-arrow{border-bottom-color:", ";&:before{transform:rotate(135deg);bottom:-17px;margin-left:7px;box-shadow:-1px 1px 2px 0px rgba(0,0,0,0.1);}}&[data-placement^='left'] .tippy-arrow{border-left-color:", ";&:before{transform:rotate(-135deg);bottom:-17px;margin-left:-7px;}}&[data-placement^='right'] .tippy-arrow{border-right-color:", ";&:before{transform:rotate(45deg);bottom:-3px;margin-left:7px;}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.depth.tooltip;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.popovers.colors.text;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.popovers.colors.background;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.popovers.colors.background;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.popovers.colors.background;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.popovers.colors.background;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.popovers.colors.background;
});
export default PopoverDefaultStyle;